import { Plus, X, Reply, ExternalLink, Phone } from "lucide-react";

const BUTTON_TYPES = [
  { value: "QUICK_REPLY", label: "Resposta rápida", Icon: Reply },
  { value: "URL", label: "Abrir URL", Icon: ExternalLink },
  { value: "PHONE_NUMBER", label: "Ligar", Icon: Phone },
];

export default function ButtonsBuilder({ buttons, onChange }) {
  const list = Array.isArray(buttons) ? buttons : [];

  function add() {
    if (list.length >= 3) return;
    onChange([...list, { type: "QUICK_REPLY", text: "" }]);
  }

  function update(i, patch) {
    const next = list.map((b, idx) => (idx === i ? { ...b, ...patch } : b));
    onChange(next);
  }

  function remove(i) {
    onChange(list.filter((_, idx) => idx !== i));
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <label className="text-xs font-medium text-ink-3">Botões (máx. 3)</label>
        <button
          type="button"
          onClick={add}
          disabled={list.length >= 3}
          className="text-xs inline-flex items-center gap-1 text-brand-400 hover:text-brand-300 disabled:text-ink-5 disabled:cursor-not-allowed"
        >
          <Plus className="w-3 h-3" /> Adicionar
        </button>
      </div>

      {list.length === 0 ? (
        <div className="text-xs text-ink-5 italic">Nenhum botão (opcional)</div>
      ) : (
        <div className="space-y-2">
          {list.map((b, i) => (
            <div key={i} className="bg-base border border-white/[0.06] rounded p-2 space-y-2">
              <div className="flex items-center gap-2">
                <select
                  value={b.type}
                  onChange={(e) => update(i, { type: e.target.value })}
                  className="bg-surface-1 border border-white/[0.08] rounded text-xs text-ink-2 px-2 py-1"
                >
                  {BUTTON_TYPES.map((t) => (
                    <option key={t.value} value={t.value}>{t.label}</option>
                  ))}
                </select>
                <input
                  type="text"
                  value={b.text || ""}
                  onChange={(e) => update(i, { text: e.target.value.slice(0, 25) })}
                  placeholder="Texto do botão (max 25)"
                  maxLength={25}
                  className="flex-1 bg-surface-1 border border-white/[0.08] rounded text-xs text-ink-2 px-2 py-1 placeholder:text-ink-5"
                />
                <button
                  type="button"
                  onClick={() => remove(i)}
                  className="text-ink-4 hover:text-red-400"
                  aria-label="Remover botão"
                >
                  <X className="w-4 h-4" />
                </button>
              </div>

              {b.type === "URL" && (
                <input
                  type="url"
                  value={b.url || ""}
                  onChange={(e) => update(i, { url: e.target.value })}
                  placeholder="https://..."
                  className="w-full bg-surface-1 border border-white/[0.08] rounded text-xs text-ink-2 px-2 py-1 placeholder:text-ink-5"
                />
              )}

              {b.type === "PHONE_NUMBER" && (
                <input
                  type="tel"
                  value={b.phone_number || ""}
                  onChange={(e) => update(i, { phone_number: e.target.value })}
                  placeholder="+5511999999999"
                  className="w-full bg-surface-1 border border-white/[0.08] rounded text-xs text-ink-2 px-2 py-1 placeholder:text-ink-5"
                />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
